/**
 * Read the API `message` field from an axios response or a thrown axios error.
 * Falls back when the body has no message, so callers never toast a blank string.
 */
export function readApiErrorMessage(responseOrError, fallback) {
  const data = responseOrError?.data ?? responseOrError?.response?.data;

  const candidates = [
    data?.message,
    data?.error?.message,
    data?.data?.message,
    data?.data?.error?.message,
    typeof data?.error === "string" ? data.error : null,
    typeof data?.data?.error === "string" ? data.data.error : null,
    typeof data === "string" ? data : null,
  ];

  for (const candidate of candidates) {
    if (typeof candidate === "string" && candidate.trim()) {
      return candidate.trim();
    }
  }
  return fallback;
}
